document.addEventListener('DOMContentLoaded', () => {
    let lastScrollTop = 0;
    let animating = false;
    let topPosHighlight = 0;
    let heightHighlight = 0; // Fixed typo in variable name
    let st = 0;

    function highlightScrollDown() {
        animating = true;
        let newScrollPos = topPosHighlight + heightHighlight;

        if (st < newScrollPos) {
            window.scrollTo({
                top: newScrollPos,
                behavior: 'smooth'
            });

            // Using setTimeout since scrollTo doesn't have a callback
            setTimeout(() => {
                animating = false;
            }, 1000);
        }
    }

    function updateHighlight() {
        const container = document.querySelector('.container-highlight');
        topPosHighlight = container.getBoundingClientRect().top + window.scrollY;
        heightHighlight = container.offsetHeight;
    }

    const highlightContainer = document.querySelector('.container-highlight');
    if (highlightContainer && highlightContainer.dataset.snap === '1') {
        updateHighlight();

        const scrollDownIcon = document.querySelector('.highlight-scroll-down > i');
        if (scrollDownIcon) {
            scrollDownIcon.addEventListener('click', () => {
                highlightScrollDown();
            });
        }

        window.addEventListener('resize', () => {
            updateHighlight();
        });

        document.addEventListener('wheel', (event) => {
            const delta = event.deltaY;

            if (delta <= 0) {
                // Scrolling up - no action needed
            } else {
                st = window.scrollY || document.documentElement.scrollTop;

                if (st > lastScrollTop) {
                    if (!animating) {
                        if ((topPosHighlight + st) > ((topPosHighlight + heightHighlight) * 0.25) &&
                            (st < (topPosHighlight + heightHighlight))) {
                            highlightScrollDown();
                        }
                    }
                }
                lastScrollTop = st;
            }
        }, { passive: true });
    }
});